import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import EventNoteIcon from '@mui/icons-material/EventNote';
import {
  Alert,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1065SchB2 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Schedule B-2 (Form 1065) Instructions CPAR Election Guide"
          description="Learn how to use Schedule B-2 (Form 1065) to elect out of Centralized Partnership Audit Regime, report eligible partner information, and verify qualifications"
          keywords=""
          canonical="resources/business-tax/schedule-b-2-form-1065-instruction/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 2,
            mt: 5,
            textAlign: 'center',
          }}
        >
          {' '}
          <span className="highlight-container">
            <span className="highlight">Schedule B-2</span>
          </span>{' '}
          (Form 1065): Election Out of the <br />
          Audit Regime
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 5,
          }}
        >
          Learn how eligible partnerships can elect out of the centralized
          partnership audit regime and <br /> how to complete Schedule B-2.
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-b-2-form-1065-instruction/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule B-2 (Form 1065) at a Glance
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="1" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of Schedule B-2 (Form 1065)
                        </strong>{' '}
                        and how eligible partnerships use it to elect out of the
                        Centralized Partnership Audit Regime (CPAR) under
                        Section 6221(b).
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="2" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Learn how to complete Schedule B-2 line by line,
                        </strong>{' '}
                        including reporting eligible partners and their TINs,
                        listing S corporation shareholders, calculating the
                        total number of Schedules K-1, and using the
                        continuation sections in Parts IV and V when needed.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="3" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the eligibility and filing requirements for
                          Schedule B-2,
                        </strong>{' '}
                        including the 100-partner limit, eligible and ineligible
                        partner types, the K-1 counting rules, and how to attach
                        the schedule to Form 1065 for each year the election is
                        made.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule B-2 (Form 1065) is used by eligible partnerships with
                  100 or fewer partners to elect out of the Centralized
                  Partnership Audit Regime (CPAR) under Section 6221(b). If the
                  partnership answers “Yes,” it must complete and attach
                  Schedule B-2 to Form 1065 and enter the total from Part III,
                  line 3. The schedule reports eligible partner information and
                  TINs to verify qualification for the election. If the
                  partnership answers “No,” it must complete the Designation of
                  Partnership Representative section instead.
                </Typography>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What is Schedule B-2?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatsnew" sx={{ color: '#0202ff' }}>
                          What’s New in Schedule B-2 (Form 1065)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#purpose" sx={{ color: '#0202ff' }}>
                          Purpose of Form
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#eligible" sx={{ color: '#0202ff' }}>
                          Eligible Partnership
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#ineligible" sx={{ color: '#0202ff' }}>
                          Ineligible Partner Types
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#who" sx={{ color: '#0202ff' }}>
                          Who Must File?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#how" sx={{ color: '#0202ff' }}>
                          How to File Schedule B-2 (Form 1065)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#linebyline" sx={{ color: '#0202ff' }}>
                          Line-by-Line Instruction for Schedule B-2
                        </Link>
                        <List sx={{ pb: 0 }}>
                          <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part1" sx={{ color: '#0202ff' }}>
                                Part I – List of Eligible Partners
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}
                          >
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part2" sx={{ color: '#0202ff' }}>
                                Part II – List of S Corporation Shareholders
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}
                          >
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part3" sx={{ color: '#0202ff' }}>
                                Part III – Total Number of Schedules K-1
                                Required to Be Issued
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}
                          >
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part4" sx={{ color: '#0202ff' }}>
                                Part IV – Continuation List of Eligible Partners
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}
                          >
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part5" sx={{ color: '#0202ff' }}>
                                Part V – Continuation of S Corporation
                                Shareholders
                              </Link>
                            </ListItemText>
                          </ListItem>
                        </List>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#import" sx={{ color: '#0202ff' }}>
                          Important Filing Tips for Schedule B-2 (Form 1065)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Mistakes to Avoid on Schedule B-2 (Form 1065)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What is Schedule B-2?
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Schedule B-2 (Form 1065) is an IRS attachment used by eligible
                  partnerships to elect out of the Centralized Partnership Audit
                  Regime (CPAR) under Section 6221(b). The schedule is filed
                  along with Form 1065 to report partner information, verify
                  eligibility requirements, and confirm that the partnership
                  qualifies for exclusion from the centralized IRS partnership
                  audit system. It is generally used by partnerships with 100 or
                  fewer eligible partners, including individuals, corporations,
                  S corporations, certain foreign entities, and estates of
                  deceased partners.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="whatsnew"
                >
                  What’s New in Schedule B-2 (Form 1065)
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    The Bipartisan Budget Act of 2015 (BBA) introduced a new
                    centralized partnership audit regime applicable to
                    partnership tax years beginning after 2017.{' '}
                  </li>
                  <li>
                    Under Section 6221(b), as amended by the BBA, partnerships
                    with
                    <span style={{ fontWeight: 600 }}>
                      100 or fewer partners
                    </span>
                    may elect out of the centralized partnership audit regime if
                    they meet eligibility requirements.{' '}
                  </li>
                  <li>
                    This provision allows qualifying partnerships to avoid
                    entity-level audit treatment and instead be handled under
                    partner-level audit rules
                  </li>
                  <li>
                    Schedule B-2 was developed to facilitate this election and
                    must be used to formally notify the IRS when a partnership
                    chooses to opt out of the centralized audit system.{' '}
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="purpose"
                >
                  Purpose of Schedule B-2 (Form 1065)
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Schedule B-2 is used by eligible partnerships to elect out
                    of the IRS centralized partnership audit regime for a tax
                    year.{' '}
                  </li>
                  <li>
                    A partnership can make this election only if it has 100 or
                    fewer eligible partners and all partners meet the IRS
                    eligibility requirements.{' '}
                  </li>
                  <li>
                    Eligible partners include individuals, C corporations, S
                    corporations, certain foreign entities treated as
                    corporations, and estates of deceased partners.
                  </li>
                  <li>
                    When calculating the total number of partners, the
                    partnership must also include shareholders of any S
                    corporation partner.{' '}
                  </li>
                  <li>
                    Partnerships making this election must complete and attach
                    Schedule B-2 to Form 1065 for the applicable tax year.{' '}
                  </li>
                  <li>
                    The form helps the IRS verify the partnership’s eligibility
                    to opt out of the centralized partnership audit system.{' '}
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="eligible"
                >
                  Eligible Partnership
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    A partnership is considered an eligible partnership if it
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      has 100 or fewer eligible partners
                    </span>{' '}
                    for the tax year.{' '}
                  </li>
                  <li>
                    The total number of partners is determined by counting
                    all&nbsp;
                    <span style={{ fontWeight: 600 }}>
                      Schedules K-1 issued by the partnership
                    </span>
                    &nbsp; for the tax year.{' '}
                  </li>
                  <li>
                    In addition, the partnership must also include the number of
                    <span style={{ fontWeight: 600 }}>
                      &nbsp;Schedules K-1 issued by any S corporation partner to
                      its shareholders&nbsp;
                    </span>
                    for the S corporation tax year that ends with or within the
                    partnership tax year.
                  </li>
                  <li>
                    This combined K-1 count is used to determine whether the
                    partnership meets the{' '}
                    <span style={{ fontWeight: 600 }}>
                      100-partner eligibility limit
                    </span>{' '}
                    for electing out of the centralized partnership audit
                    regime.{' '}
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="ineligible"
                >
                  Ineligible Partner Types
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  A partnership is{' '}
                  <span style={{ fontWeight: 600 }}>
                    not eligible to elect out
                  </span>{' '}
                  of the centralized partnership audit regime if it is required
                  to issue a Schedule K-1 to any of the following partner types:
                  .
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Another partnership (as partners) </li>
                  <li>A trust </li>
                  <li>
                    A foreign entity that would not be treated as a C
                    corporation if it were a domestic entity{' '}
                  </li>
                  <li>
                    A disregarded entity (as described in Regulations section
                    301.7701-2(c)(2)(i)){' '}
                  </li>
                  <li>
                    An estate of an individual other than a deceased
                    partner{' '}
                  </li>
                  <li>
                    Any person holding an interest in the partnership on behalf
                    of another person If any of the above partner types are
                    present, the partnership{' '}
                    <span style={{ fontWeight: 600 }}>
                      does not qualify for the Schedule B-2 election
                    </span>
                    .
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="who"
                >
                  Who Must File Schedule B-2
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Partnerships, including
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Real Estate Mortgage Investment Conduits (REMICs)
                    </span>
                    , must complete Schedule B-2 if they choose to elect out of
                    the centralized partnership audit regime.{' '}
                  </li>
                  <li>
                    The form must be filed{' '}
                    <span style={{ fontWeight: 600 }}>for every tax year</span>{' '}
                    in which the election is intended to be effective.{' '}
                  </li>
                  <li>
                    Each annual filing is required to ensure the election
                    remains valid for that specific tax year.{' '}
                  </li>
                  <li>
                    The Schedule B-2 must be{' '}
                    <span style={{ fontWeight: 600 }}>
                      accurately completed and attached
                    </span>{' '}
                    to the partnership’s tax return.{' '}
                  </li>
                  <li>
                    If the form is not completed correctly, the IRS may
                    determine that the election is{' '}
                    <span style={{ fontWeight: 600 }}>invalid</span>, and the
                    partnership may remain subject to the centralized
                    partnership audit regime.{' '}
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="how"
                >
                  How to File Schedule B-2
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Schedule B-2 must be{' '}
                    <span style={{ fontWeight: 600 }}>
                      attached to Form 1065
                    </span>{' '}
                    when filing the partnership return.{' '}
                  </li>
                  <li>
                    In the case of a
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Real Estate Mortgage Investment Conduit (REMIC)
                    </span>
                    , the form must be attached to{' '}
                    <span style={{ fontWeight: 600 }}>Form 1066</span>.
                  </li>
                  <li>
                    The return must be{' '}
                    <span style={{ fontWeight: 600 }}>timely filed</span>,{''}{' '}
                    including any approved extensions.{' '}
                  </li>
                  <li>
                    Schedule B-2 must be submitted{' '}
                    <span style={{ fontWeight: 600 }}>for every tax year</span>{' '}
                    in which the partnership elects out of the centralized
                    partnership audit regime.{' '}
                  </li>
                  <li>
                    Failure to attach the form properly or file on time may
                    result in the election being treated as{' '}
                    <span style={{ fontWeight: 600 }}>invalid by the IRS</span>.
                    {''}{' '}
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="linebyline"
                >
                  Line-by-Line Instruction for Schedule B-2 (Form 1065)
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Basic Information
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Before completing Schedule B-2, provide the partnership's
                  identifying information at the top of the form.
                </Typography>
                <picture>
                  <source srcSet="/assets/images/f1065-schb2-img.webp" />
                  <source srcSet="/assets/images/f1065-schb2-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1065-schb2-img.png"
                    loading="lazy"
                    alt="Schedule B-2 (Form 1065) basic information showing partnership name and EIN"
                    width={760}
                    height={101}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Name of Partnership –{' '}
                  </span>
                  Enter the partnership's legal name exactly as it appears on
                  Form 1065 and IRS records.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Employer Identification Number (EIN) –{' '}
                  </span>
                  Enter the partnership's IRS-issued nine-digit EIN exactly as
                  reported on Form 1065.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="part1"
                >
                  Part I – List of Eligible Partners
                </Typography>
                <picture>
                  <source srcSet="/assets/images/part-i-list-of-eligible-img.webp" />
                  <source srcSet="/assets/images/part-i-list-of-eligible-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/part-i-list-of-eligible-img.png"
                    loading="lazy"
                    alt="Schedule B-2 Part I listing eligible partner types and codes for individuals, corporations, estates, foreign entities, and S corporations"
                    width={760}
                    height={352}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Coumn1 – Name of Entity Owner
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the full legal name of each partner who must receive a
                  Schedule K-1 from the partnership for the tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 2 – Taxpayer Identification Number (TIN)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the correct U.S. TIN for each partner. The TIN must be
                  accurate; incorrect or missing TINs may result in validation
                  errors and may cause the IRS to treat the election as invalid.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 3 – Type of Eligible Partner (Code)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the appropriate code for each partner using only the
                  following values:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>I – Individual</li>
                  <li>C – Corporation</li>
                  <li>S – S corporation </li>
                  <li>E – Estate of deceased partner </li>
                  <li>
                    F – Eligible foreign entity treated as a C corporation if
                    domestic{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If the partnership has more than{' '}
                  <span style={{ fontWeight: 600 }}>15 partners</span>,{''}{' '}
                  continue listing additional partners in{' '}
                  <span style={{ fontWeight: 600 }}>
                    Part IV (Continuation List of Eligible Partners)
                  </span>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  By completing Part I, the partnership certifies that all
                  listed partners meet the eligibility requirements under
                  Section 6221(b)(1)(C) and that all required information has
                  been accurately provided.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="part2"
                >
                  Part II – List of S Corporation Shareholders
                </Typography>
                <picture>
                  <source srcSet="/assets/images/part-ii-list-of-s-corporation-img.webp" />
                  <source srcSet="/assets/images/part-ii-list-of-s-corporation-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/part-ii-list-of-s-corporation-img.png"
                    loading="lazy"
                    alt="Schedule B-2 Part II listing S corporation shareholders and type codes for individuals, estates, trusts, and other persons"
                    width={760}
                    height={344}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 1 – Name of S Corporation Partner
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the full legal name of the S corporation that is a
                  partner in the partnership. A separate Part II must be
                  completed for each S corporation partner.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 2 – TIN of Partner
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the correct U.S. Taxpayer Identification Number (TIN) of
                  the S corporation partner. The TIN must be accurate; incorrect
                  or missing TINs may result in validation errors and may cause
                  the IRS to treat the election as invalid.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 3 – Name of Shareholder
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the full legal name of each shareholder of the S
                  corporation for the tax year ending with or within the
                  partnership tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 4 – Shareholder TIN
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the correct U.S. TIN for each shareholder. The TIN must
                  be accurate; incorrect or missing information may affect the
                  validity of the election.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Column 5 – Type of Person (Code)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the appropriate code for each shareholder using only the
                  following values:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>I – Individual </li>
                  <li>T – Trust </li>
                  <li>E – Estate of deceased shareholder </li>
                  <li>O – Other </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  “Other” includes pension plans under section 401(a), including
                  ESOPs, section 501(c)(3) charitable organizations, and
                  eligible disregarded entities.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If there are more than 12 shareholders for an S corporation
                  partner,{' '}
                  <span style={{ fontWeight: 600 }}>
                    continue listing the shareholders in Part V
                  </span>{' '}
                  (Continuation Sheet) for the same S corporation.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  By completing Part II, the partnership certifies that all S
                  corporation shareholder information is complete, accurate, and
                  properly reported as required under the Schedule B-2 filing
                  rules.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="part3"
                >
                  Part III – Total Number of Schedules K-1 Required to Be Issued
                </Typography>
                <picture>
                  <source srcSet="/assets/images/part-iii-total-number-of-schedules-img.webp" />
                  <source srcSet="/assets/images/part-iii-total-number-of-schedules-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/part-iii-total-number-of-schedules-img.png"
                    loading="lazy"
                    alt="Schedule B-2 Part III showing total number of Schedules K-1 required to be issued"
                    width={760}
                    height={102}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 1 – Total Partners (Part I + Part IV)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the total number of Schedules K-1 required to be issued
                  by the partnership. This includes all partners listed in Part
                  I and any additional partners listed in Part IV (Continuation
                  List).
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 2 – Total S Corporation Shareholders (Part II + Part V)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the total number of Schedules K-1 required to be issued
                  by all S corporation partners to their shareholders. This
                  includes all shareholders reported in Part II and any
                  additional shareholders listed in Part V. Do not include the S
                  corporation partner itself in this count, as it is already
                  included in Line 1.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 3 – Total Count
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Add Line 1 and Line 2 and enter the total number of Schedules
                  K-1 required to be issued for the tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Reporting Requirement
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The total from Line 3 must also be carried to Form 1065,
                  Schedule B, Question 25.
                </Typography>
                <Alert
                  severity="warning"
                  icon={<EventNoteIcon />}
                  sx={{
                    mb: 2,
                    mt: 2,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                  }}
                >
                  <b>Note:</b> If the total on Line 3 exceeds 100, the
                  partnership does not qualify to elect out of the centralized
                  partnership audit regime under Section 6221(b).
                </Alert>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="part4"
                >
                  Part IV – Continuation List of Eligible Partners
                </Typography>
                <picture>
                  <source srcSet="/assets/images/part-iv-continuation-list-of-eligible-img.webp" />
                  <source srcSet="/assets/images/part-iv-continuation-list-of-eligible-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/part-iv-continuation-list-of-eligible-img.png"
                    loading="lazy"
                    alt="Schedule B-2 Part IV continuing the list of eligible partners with codes"
                    width={760}
                    height={327}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    Complete Part IV only if the partnership is required to
                    issue Schedules K-1 to
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      more than 15 partners
                    </span>
                    .
                  </li>
                  <li>
                    This section is a continuation of{' '}
                    <span style={{ fontWeight: 600 }}>
                      Part I – List of Eligible Partners
                    </span>
                    .{' '}
                  </li>
                  <li>
                    Enter all additional eligible partners using the same
                    details required in Part I:
                    <Box
                      component="ul"
                      sx={{ mb: 2, mt: 2, '& li': { mb: 1.2 } }}
                    >
                      <li>Partner name </li>
                      <li>Taxpayer Identification Number (TIN) </li>
                      <li>Type of eligible partner code </li>
                    </Box>
                  </li>
                  <li>
                    Ensure all information entered in this section is complete
                    and accurate and follows the same eligibility rules as Part
                    I.{' '}
                  </li>
                  <li>
                    Part IV is used only to extend the list of eligible partners
                    and does not change the partnership’s eligibility to make
                    the election under Section 6221(b).{' '}
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="part5"
                >
                  Part V – Continuation of S Corporation Shareholders
                </Typography>
                <picture>
                  <source srcSet="/assets/images/part-v-continuation-of-s-corporation-img.webp" />
                  <source srcSet="/assets/images/part-v-continuation-of-s-corporation-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/part-v-continuation-of-s-corporation-img.png"
                    loading="lazy"
                    alt="Schedule B-2 Part V continuing the list of S corporation shareholders with codes for individuals, estates, trusts, and others"
                    width={760}
                    height={429}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    Complete Part V only if the S corporation partner is
                    required to issue Schedules K-1 to{' '}
                    <span style={{ fontWeight: 600 }}>
                      more than 12 shareholders
                    </span>
                    .{' '}
                  </li>
                  <li>
                    This section is a continuation of{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Part II – List of S Corporation Shareholders
                    </span>
                    .{' '}
                  </li>
                  <li>
                    Always include the{' '}
                    <span style={{ fontWeight: 600 }}>
                      name of the S corporation partner and its U.S. Taxpayer
                      Identification Number (TIN)
                    </span>
                    at the top of the page for proper identification of the
                    shareholder group.{' '}
                  </li>
                  <li>
                    Enter all additional shareholders using the same details
                    required in Part II:
                    <Box
                      component="ul"
                      sx={{ mb: 2, mt: 2, '& li': { mb: 1.2 } }}
                    >
                      <li>Shareholder name </li>
                      <li>Shareholder Taxpayer Identification Number (TIN) </li>
                      <li>Type of person code </li>
                    </Box>
                  </li>
                  <li>
                    Use the same classification codes as Part II:
                    <Box
                      component="ul"
                      sx={{ mb: 2, mt: 2, '& li': { mb: 1.2 } }}
                    >
                      <li>I – Individual </li>
                      <li>T – Trust </li>
                      <li>E – Estate of deceased shareholder </li>
                      <li>O – Other </li>
                    </Box>
                  </li>
                  <li>
                    Ensure all information entered in this section is complete,
                    accurate, and consistent with Part II reporting
                    requirements.{' '}
                  </li>
                  <li>
                    Part V is used only to extend the shareholder listing and
                    does not change the partnership’s eligibility under Section
                    6221(b).{' '}
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="import"
                >
                  Important Filing Tips – Schedule B-2 (Form 1065)
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Confirm the partnership is eligible (100 or fewer partners,
                    and all must be eligible partner types).{' '}
                  </li>
                  <li>
                    Correctly apply the{' '}
                    <span style={{ fontWeight: 600 }}>K-1 counting rule</span>,{' '}
                    including S corporation shareholders.
                  </li>
                  <li>
                    Use only valid partner codes (individual,
                    corporation,S-corporation, estate, Eligible foreign entity).
                  </li>

                  <li>
                    Enter accurate and complete{' '}
                    <span style={{ fontWeight: 600 }}>TINs</span> for all
                    partners and shareholders.
                  </li>
                  <li>
                    Include all required details for{' '}
                    <span style={{ fontWeight: 600 }}>
                      S corporation shareholders
                    </span>
                    , using Part V if needed.
                  </li>
                  <li>
                    Use{' '}
                    <span style={{ fontWeight: 600 }}>Part IV and Part V</span>{' '}
                    when partner or shareholder limits exceed the form space.
                  </li>

                  <li>
                    Attach Schedule B-2 to a{' '}
                    <span style={{ fontWeight: 600 }}>
                      timely filed Form 1065 (or Form 1066 for REMICs)
                    </span>
                    .
                  </li>
                  <li>
                    Complete the form
                    <span style={{ fontWeight: 600 }}>every year</span>
                    the election is made.
                  </li>
                  <li>
                    Double-check all entries to avoid errors that may invalidate
                    the election.
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Mistakes to Avoid – Schedule B-2 (Form 1065)
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Not including{' '}
                    <span style={{ fontWeight: 600 }}>
                      S corporation shareholders
                    </span>{' '}
                    in the total partner count
                  </li>
                  <li>
                    Listing{' '}
                    <span style={{ fontWeight: 600 }}>ineligible partners</span>{' '}
                    (trusts, partnerships, disregarded entities, etc.)
                  </li>

                  <li>
                    Entering{' '}
                    <span style={{ fontWeight: 600 }}>
                      incorrect or missing TINs
                    </span>
                  </li>
                  <li>
                    Using wrong{' '}
                    <span style={{ fontWeight: 600 }}>
                      partner or shareholder codes
                    </span>
                  </li>
                  <li>
                    Not using{' '}
                    <span style={{ fontWeight: 600 }}>Part IV or Part V</span>{' '}
                    when required
                  </li>
                  <li>
                    Failing to attach the form to a{' '}
                    <span style={{ fontWeight: 600 }}>timely filed return</span>
                  </li>
                  <li>
                    Not meeting the{' '}
                    <span style={{ fontWeight: 600 }}>
                      100-partner eligibility rule
                    </span>
                  </li>
                  <li>Providing incomplete or inconsistent information</li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. What is the purpose of Schedule B-2 (Form 1065)?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule B-2 (Form 1065) is used by eligible partnerships to
                  elect out of the centralized partnership audit regime (CPAR)
                  under Section 6221(b). It helps the IRS verify that the
                  partnership meets the eligibility requirements, including
                  partner type and total partner count, before allowing the
                  election.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Who must file Schedule B-2 (Form 1065)?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Partnerships (including REMICs) must file Schedule B-2 if they
                  choose to elect out of CPAR for a tax year and meet the
                  eligibility rules. The form must be attached to Form 1065 for
                  every year the election is made.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. Is Schedule B-2 filed separately from Form 1065?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  No. Schedule B-2 must be attached to Form 1065 (or Form 1066
                  for REMICs). It cannot be filed as a separate standalone form.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Where can I find Schedule B-2 (Form 1065) instructions?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  You can find Schedule B-2 (Form 1065) instructions on the
                  official IRS website or through authorized tax filing
                  platforms that support Form 1065 e-filing, such as TaxZerone.
                  These resources provide detailed guidance on eligibility
                  rules, partner and shareholder reporting requirements, K-1
                  counting rules, and step-by-step instructions for completing
                  Parts I through V of Schedule B-2 when electing out of the
                  centralized partnership audit regime.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      {/* <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with Schedule K-1 Using TaxZerone
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure each shareholder’s income, deductions, and credits are
              accurately reported and IRS-compliant.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=schk1`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container> */}
    </AppLayout>
  );
};

export default Form1065SchB2;
